export default __webpack_public_path__ + "static/media/gan.f066a6be.png";